import React, { useContext } from "react";
import "./styles.css"; // Optional: Import CSS for styling
import { createPortal } from "react-dom";
import paperDimensions from "../../../public/assets/paperDimensions.png";
import smallBox from "../../../public/assets/smallBox.png";
import midiumBox from "../../../public/assets/midiumBox.png";
import bigBox from "../../../public/assets/bigBox.png";

import paperDimensionsEs from "../../../public/assets/paperDimensionsEs.png";
import smallBoxEs from "../../../public/assets/smallBoxEs.png";
import midiumBoxEs from "../../../public/assets/midiumBoxEs.png";
import bigBoxEs from "../../../public/assets/bigBoxEs.png";

import { useTranslation } from "react-i18next";
import { quoteContext } from "../../context/quotesContext";

const Modal = ({ show, handleClose }) => {
  const { getLenguaje } = useContext(quoteContext);
  const [t, i18n] = useTranslation();
  if (!show) return null;

  return createPortal(
    <div className="modal">
      <div className="modal-content">
        <button className="modal-close" onClick={handleClose}>
          ×
        </button>
        <div className="measurement-guide">
          <h2>{t('measurementGuide')}</h2>
          <div className="measurement-grid">
            <div className="measurement-row">
              <div className="measurement-item">
                <div className="image-dimension-continer">
                  <img
                    className="measurement-image"
                    src={ getLenguaje()=='es'?paperDimensionsEs:paperDimensions}
                    alt="Paper envelope"
                  />
                </div>

                <h3 className="measurement-item-title">
                  {t('paper_envelope')}
                </h3>
                <div className="container-measurement-table">
                  <div className="header-measurement-table">
                    <div className="header-item"></div>
                    <div className="header-item">cm</div>
                    <div className="header-item no-border"> {t('inch')}</div>
                  </div>
                  <div className="dimensions-content">
                    <div className="dimension">
                      <div className="dimension-title">{t('long')}</div>
                      <div>1 cm</div>
                      <div className="no-border">1 {t('inch')}</div>
                    </div>
                    <div className="dimension">
                      <div className="dimension-title">{t('broad')}</div>
                      <div>25 cm</div>
                      <div className="no-border">9 {t('inch')}</div>
                    </div>
                    <div className="dimension">
                      <div className="dimension-title">{t('high')}</div>
                      <div>35 cm</div>
                      <div className="no-border">12 {t('inch')}</div>
                    </div>
            
                  </div>
                </div>
              </div>
              <div className="measurement-item">
                <div className="image-dimension-continer">
                  <img
                    className="measurement-image"
                    src={getLenguaje()=='es'?smallBoxEs:smallBox}
                    alt="Paper envelope"
                  />
                </div>
                <h3 className="measurement-item-title">
                  {t('small_box')}
                  <span> {t('small_box_max')}</span>
                </h3>
                <div className="container-measurement-table">
                  <div className="header-measurement-table">
                    <div className="header-item"></div>
                    <div className="header-item">cm</div>
                    <div className="header-item no-border">{t('inch')}</div>
                  </div>
                  <div className="dimensions-content">
                    <div className="dimension">
                      <div className="dimension-title">{t('long')}</div>
                      <div>35 cm</div>
                      <div className="no-border">12 {t('inch')}</div>
                    </div>
                    <div className="dimension">
                      <div className="dimension-title">{t('broad')}</div>
                      <div>25 cm</div>
                      <div className="no-border">9 {t('inch')}</div>
                    </div>
                    <div className="dimension">
                      <div className="dimension-title">{t('high')}</div>
                      <div>25 cm</div>
                      <div className="no-border">9 {t('inch')}</div>
                    </div>
             
                  </div>
                </div>
              </div>
            </div>
            <div className="measurement-row">
              <div className="measurement-item">
                <div className="image-dimension-continer">
                  <img
                    className="measurement-image"
                    src={getLenguaje()=='es'?midiumBoxEs:midiumBox}
                    alt="Paper envelope"
                  />
                </div>
                <h3 className="measurement-item-title">
                  {t('medium_box')}
                  <span>  {t('medium_box_max')}</span>
                </h3>

                <div className="container-measurement-table">
                  <div className="header-measurement-table">
                    <div className="header-item"></div>
                    <div className="header-item">cm</div>
                    <div className="header-item no-border">{t('inch')}</div>
                  </div>

                  <div className="dimensions-content">
                    <div className="dimension">
                      <div className="dimension-title">{t('long')}</div>
                      <div>35 cm</div>
                      <div className="no-border">12 {t('inch')}</div>
                    </div>
                    <div className="dimension">
                      <div className="dimension-title">{t('broad')}</div>
                      <div>25 cm</div>
                      <div className="no-border">9 {t('inch')}</div>
                    </div>
                    <div className="dimension">
                      <div className="dimension-title">{t('high')}</div>
                      <div>25 cm</div>
                      <div className="no-border">9 {t('inch')}</div>
                    </div>
              
                  </div>
                </div>
              </div>
              <div className="measurement-item">
                <div className="image-dimension-continer">
                  <img
                    className="measurement-image"
                    src={getLenguaje()=='es'?bigBoxEs:bigBox}
                    alt="Paper envelope"
                  />
                </div>
                <h3 className="measurement-item-title">
                  {t('large_box')}
                  <span>{t('max_largebox')}</span>
                </h3>
                <div className="container-measurement-table">
                  <div className="header-measurement-table">
                    <div className="header-item"></div>
                    <div className="header-item">cm</div>
                    <div className="header-item no-border">{t('inch')}</div>
                  </div>
                  <div className="dimensions-content">
                    <div className="dimension">
                      <div className="dimension-title">{t('long')}</div>
                      <div>35 cm</div>
                      <div className="no-border">12 {t('inch')}</div>
                    </div>
                    <div className="dimension">
                      <div className="dimension-title">{t('broad')}</div>
                      <div>25 cm</div>
                      <div className="no-border">9 {t('inch')}</div>
                    </div>
                    <div className="dimension">
                      <div className="dimension-title">{t('high')}</div>
                      <div>25 cm</div>
                      <div className="no-border">9 {t('inch')}</div>
                    </div>
                 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("modal-root")
  );
};

export { Modal };
